export const MODAL_TYPES = {
  DELETE: 'DELETE',
  CLONE: 'CLONE',
  UNPUBLISH: 'UNPUBLISH',
  ARCHIVE: 'ARCHIVE',
  PREVIEW_CTA: 'PREVIEW_CTA',
  EMBEDDING_INFO: 'EMBEDDING_INFO',
  DETAILS_PANEL: 'DETAILS_PANEL',
  RUN_AB_TEST: 'RUN_AB_TEST',
  MANAGE_ACCESS: 'MANAGE_ACCESS',
  PICK_AB_TEST_WINNER: 'PICK_AB_TEST_WINNER',
  GENERATE_WITH_AI: 'GENERATE_WITH_AI',
  PERSONALIZATION_VARIANTS_MODAL: 'PERSONALIZATION_VARIANTS_MODAL'
};